export const BASEURL = "https://mobibackend.onrender.com"

//"https://mobibackend.onrender.com"

//"http://localhost:5000";
